/**
 * @generated SignedSource<<3bb251200fc6fbd0b59cca766c0c395f>>
 * @relayHash 3fac23e69ad72cef246c33b6b22b24bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 977d9e099882e8a74d82099a73a8a2401956aa3722a387c1dad0080809f1647f

import type { ConcreteRequest } from 'relay-runtime';
export type ArchivedPageBannerV2ArchivedPageBannerQuery$variables = {
  contentId?: string | null | undefined;
};
export type ArchivedPageBannerV2ArchivedPageBannerQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly archivedContentMetadata: {
        readonly archiveNote: string | null | undefined;
      } | null | undefined;
      readonly history: {
        readonly lastUpdated: {
          readonly by: {
            readonly accountId?: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null | undefined;
        readonly targetType: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ArchivedPageBannerV2ArchivedPageBannerQuery = {
  response: ArchivedPageBannerV2ArchivedPageBannerQuery$data;
  variables: ArchivedPageBannerV2ArchivedPageBannerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  },
  {
    "kind": "Literal",
    "name": "status",
    "value": [
      "archived",
      "current"
    ]
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "type"
},
v4 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v5 = {
  "concreteType": "ArchivedContentMetadata",
  "kind": "LinkedField",
  "name": "archivedContentMetadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "archiveNote"
    }
  ]
},
v6 = [
  {
    "kind": "ScalarField",
    "name": "accountId"
  }
],
v7 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "KnownUser"
},
v8 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "UnknownUser"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "lastUpdated",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "lastUpdated",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          (v7/*: any*/),
                          (v8/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "3fac23e69ad72cef246c33b6b22b24bc",
    "id": "977d9e099882e8a74d82099a73a8a2401956aa3722a387c1dad0080809f1647f",
    "metadata": {},
    "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
    "operationKind": "query",
    "text": "query ArchivedPageBannerV2ArchivedPageBannerQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,type,operations{operation,targetType},archivedContentMetadata{archiveNote},history{lastUpdated{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}}}}"
  }
};
})();

(node as any).hash = "e569274206c06e3436e0c3de5c5fe595";

export default node;
